import { action } from '@play-co/replicant';
import createActions from 'src/replicant/config/actions/createActions';
import { joinActiveRace, claimRaceRewards } from './races.modifiers';
import { getActiveRace, getRaceStartTime } from './races.getters';
import { RaceGoal } from './races.ruleset';
import { updateRaceBotsOnPopupOpen } from './races.bots';

export const match2RacesActions = createActions({
  joinMatch2Race: action((state, _: void, api) => {
    joinActiveRace(state, api);
  }),

  recordMatch2LastViewedScore: action(
    (state, { auto }: { auto: boolean }, api) => {
      const now = api.date.now();
      const { id } = getActiveRace(now)!;
      const raceIndex = (state.match2.races[id]?.length ?? 1) - 1;

      const { lastViewedRaceScore } = state.match2;
      const isDifferentRace =
        lastViewedRaceScore?.raceId !== id &&
        lastViewedRaceScore?.raceIndex !== raceIndex;

      state.match2.lastViewedRaceScore = {
        raceId: id,
        raceIndex,
        score: state.match2.races[id]?.[raceIndex]?.score ?? 0,
        timestamp: now,
        autoShowed: isDifferentRace
          ? auto
          : lastViewedRaceScore?.autoShowed || auto,
      };
    },
  ),

  addMatch2RaceScore: action(
    (state, { goal, score }: { goal: RaceGoal; score: number }, api) => {
      // No race to add score to.
      if (!state.match2.pendingRaceScore) return;

      // Get race config.
      const activeRace = getActiveRace(
        getRaceStartTime(state.match2.pendingRaceScore.raceId),
      )!;

      // Only count score if goal matches.
      if (activeRace.config.goal !== goal) return;
      // Update score.
      state.match2.pendingRaceScore.score += score;
    },
  ),

  claimMatch2RaceRewards: action(
    (
      state,
      { raceId, raceIndex }: { raceId: string; raceIndex: number },
      api,
    ) => {
      claimRaceRewards(state, raceId, raceIndex, api);
    },
  ),

  /**
   * Update online bots logic before showing any rewards or leaderboards.
   */
  updateMatch2RaceBots: action((state, _: void, api) => {
    updateRaceBotsOnPopupOpen(state, api.date.now());
  }),
});
